import React from 'react';
import videoUtils from '../utils/VideoUtils';
import mouseUtils from '../utils/MouseUtils';
import appParameters from '../utils/AppParameters';
import hoverManager from '../utils/HoverManager';
import textSizeUtils from '../utils/TextSizeUtils';

export const VideoMarker = React.createClass({
    getInitialState() {
        return {
            isMarkerVisible: false,
            isMouseDown: false,
            isSplitVisible: false,
            isSplitOver: false
        }
    },
    componentDidMount() {
        this.refs.track.addEventListener('touchstart', this.onMouseDown);
        document.addEventListener('touchmove', this.onMouseMove);
        document.addEventListener('touchend', this.onMouseUp);

        this.refs.track.addEventListener('mousedown', this.onMouseDown);
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);

        videoUtils.markerUpdateHandler = this.updateMarker;
        videoUtils.updateMarkerVisbility = this.updateMarkerVisbility;
    },
    componentWillUnmount() {
        this.refs.track.removeEventListener('touchstart', this.onMouseDown);
        document.removeEventListener('touchmove', this.onMouseMove);
        document.removeEventListener('touchend', this.onMouseUp);

        this.refs.track.removeEventListener('mousedown', this.onMouseDown);
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);

        videoUtils.markerUpdateHandler = undefined;
        videoUtils.updateMarkerVisbility = undefined;
    },
    onSplitMouseIn() {
        hoverManager.show(this.refs.split, 'SplitClipHover');

        this.setState({
            isSplitOver: true
        });
    },
    onSplitMouseOut () {
        hoverManager.hide();

        this.setState({
            isSplitOver: false
        });
    },
    updateMarker(isStart = true, isEnd = false) {
        if (isStart)
            this.start();
        else
            this.stop(isEnd);
    },
    start() {
        if (this.state.intervalVar)
            clearInterval(this.state.intervalVar);

        var markerPosition = videoUtils.getMarkerPosition();
        var intervalTime = 10;
        var distance = videoUtils.rightMarkerPosition - markerPosition;
        var time = (videoUtils.getOutPoint() - videoUtils.getCurrentPoint()) * 1000;
        var offSet = (distance * intervalTime) / time;
        var intervalVar = setInterval(this.setPosition, intervalTime);

        this.setState({
            intervalVar,
            offSet,
            currentPosition: markerPosition,
            isMarkerVisible: true,
            isSplitVisible: false
        });
    },
    stop(isEnd) {
        if (this.state.intervalVar)
            clearInterval(this.state.intervalVar);

        if (!isEnd)
            videoUtils.markerPosition = this.state.currentPosition;
        else
            videoUtils.markerPosition = videoUtils.leftMarkerPosition;

        if (this.refs.marker) {
            this.refs.marker.style.left = videoUtils.markerPosition + 'px';
            this.refs.split.style.left = (videoUtils.markerPosition + this.splitOffset()) + 'px';
        }
    },
    setPosition() {
        var position = this.state.currentPosition + this.state.offSet;

        this.setState({
            currentPosition: position
        });

        this.refs.marker.style.left = position + 'px';
        this.refs.split.style.left = (position + this.splitOffset())+ 'px';
    },
    onMouseDown(e) {
        var position = mouseUtils.getTouchPosition(e);
        var offset;

        if (e.offsetX >= 0)
            offset = e.offsetX;
        else
            offset = position.x - this.props.globalLeft;

        this.moveMarker(offset);

        this.setState({
            isMouseDown: true,
            clientX: position.x,
            startPosition: videoUtils.markerPosition,
            isSplitVisible: true
        });
    },
    onMouseMove(e) {
        if (this.state.isMouseDown) {
            var globalPosition = mouseUtils.getTouchPosition(e);
            var position = this.state.startPosition + (globalPosition.x - this.state.clientX);
            this.moveMarker(position);
        }
    },
    onMouseUp() {
        if (textSizeUtils.isTextEditMode())
            return;

        this.setState({
            isMouseDown: false
        });
    },
    moveMarker(position) {
        var newPosition = position;

        if (newPosition > videoUtils.leftMarkerPosition && newPosition < videoUtils.rightMarkerPosition) {
            this.refs.marker.style.left = newPosition + 'px';
            this.refs.split.style.left = (newPosition + this.splitOffset())+ 'px';

            videoUtils.updateMarkerPosition(newPosition);

            this.updateMarkerVisbility(true);
        }
    },
    splitOffset() {
        return -14.5;
    },
    updateMarkerVisbility(isVisible = false) {
        if (!isVisible) {
            this.setState({
                isMarkerVisible: isVisible,
                isSplitVisible: false
            });
        } else {
            this.setState({
                isMarkerVisible: isVisible
            });
        }
    },
    onSplitClick() {
        videoUtils.splitClip();
    },
    render() {
        const divStyle = {
            position: 'absolute',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            width: this.props.trackWidth,
            height: this.props.trackHeight
        };

        const backgroundStyle = {
            position: 'absolute',
            width: this.props.trackWidth,
            height: this.props.trackHeight
        };

        var isVisible = 'none';

        if (this.state.isMarkerVisible)
            isVisible = 'block';

        const markerStyle = {
            position: 'absolute',
            width: 3,
            height: this.props.trackHeight,
            background: '#272727',
            display: isVisible
        };

        var splitSrc = appParameters.RESOURCES_LOCATION() + 'assets/split.png';

        isVisible = 'none';

        if (this.state.isSplitVisible)
            isVisible = 'block';

        const splitStyle = {
            position: 'absolute',
            height: 40,
            top: -40,
            left: 0,
            display: isVisible
        };

        return (
            <div style={divStyle}>
                <img alt='' aria-hidden='true' ref='split' style={splitStyle} src={splitSrc} onTouchEnd={this.onSplitClick} onMouseDown={this.onSplitClick} onMouseOver={this.onSplitMouseIn} onMouseOut={this.onSplitMouseOut}/>
                <div ref='marker' id='marker' style={markerStyle}/>
                <canvas ref='track' style={backgroundStyle}/>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/videoEditor/VideoMarker.js
 **/